import { Menu, styled } from '@mui/material';
import { ReactComponent as AngleDown } from 'images/header/angle-down.svg';

export const FilterMenuButton = styled('button')({
  padding        : '10px 14px',
  color          : '#00778B',
  fontWeight     : 700,
  width          : '140px',
  display        : 'flex',
  justifyContent : 'space-between',
  alignItems     : 'center',
  background     : '#fff',
  border         : '1px solid #E9E9E9',
  borderRadius   : '6px',
  cursor         : 'pointer',
});

export const StyledAngle = styled(AngleDown, {
  shouldForwardProp : (props) => props !== 'isMenuOpen',
})(({ isMenuOpen }) => ({
  transform  : `rotate(${isMenuOpen ? 180 : 0}deg)`,
  marginLeft : '12px',
}));

export const StyledMenu = styled(Menu)({
  '& .MuiMenu-paper' : {
    right : '78px',
  },
});
